/** @jsxImportSource @emotion/react */
import React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown} from "@fortawesome/pro-regular-svg-icons";
import {CustomThemeContext} from "js/common/themes/CustomThemeProvider";

const PresentationSplitButton = ({onViewCurrent, onPresentFromTab, onPresentFromBeginning, presentDisabled = false}) => {
  const {theme} = React.useContext(CustomThemeContext);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleDropdownOpen = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  const greyBorder = `1px solid ${theme.palette.border.light}`;
  const greyBorderDark = `1px solid ${theme.palette.text.disabled || theme.palette.text.secondary}`;

  const sharedButtonSx = {
    textTransform: "uppercase",
    fontSize: "0.7rem",
    letterSpacing: "0.05em",
    boxShadow: "none",
    height: 30,
    border: greyBorder,
    color: theme.palette.text.secondary,
    // position + zIndex on hover lets the hovered button's full (4-sided) border render
    // above its neighbour, so the shared edge isn't clipped by the adjacent button.
    position: "relative",
    "&:hover": {boxShadow: "none", border: greyBorderDark, backgroundColor: "transparent", zIndex: 1}
  };

  return (
      <div style={{display: "flex", alignItems: "center"}}>
        <Button
            variant="outlined"
            size="small"
            startIcon={<i className="bhi-overview" style={{fontSize: "0.85rem"}} />}
            onClick={onViewCurrent}
            data-test-id="view-current-tab-button"
            sx={{...sharedButtonSx, borderRadius: "4px 0 0 4px", whiteSpace: "nowrap", marginRight: "-1px"}}>
          View current tab
        </Button>
        <Tooltip title={presentDisabled ? "Every tab is skipped in presentation" : ""} arrow>
          {/* span wrapper so the tooltip still shows while the button is disabled */}
          <span style={{display: "inline-flex"}}>
            <Button
                variant="outlined"
                size="small"
                disabled={presentDisabled}
                onClick={handleDropdownOpen}
                data-test-id="presentation-dropdown-button"
                sx={{...sharedButtonSx, borderRadius: "0 4px 4px 0", minWidth: 0, padding: "0 8px"}}>
              <FontAwesomeIcon icon={faChevronDown} style={{fontSize: "0.65rem"}} />
            </Button>
          </span>
        </Tooltip>
        <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            PaperProps={{sx: {backgroundColor: theme.palette.background.card}}}>
          <MenuItem onClick={() => { onPresentFromTab(); handleClose(); }} data-test-id="menu-present-from-tab">
            <ListItemIcon style={{minWidth: 24}}>
              <i className="bhi-desktop" style={{fontSize: "0.8rem", color: theme.palette.text.main}} />
            </ListItemIcon>
            <ListItemText primaryTypographyProps={{fontSize: "0.8rem"}}>Present from this tab</ListItemText>
          </MenuItem>
          <MenuItem onClick={() => { onPresentFromBeginning(); handleClose(); }} data-test-id="menu-present-from-beginning">
            <ListItemIcon style={{minWidth: 24}}>
              <i className="ri-skip-back-mini-fill" style={{fontSize: "1.1rem", marginLeft: "-2px", color: theme.palette.text.main}} />
            </ListItemIcon>
            <ListItemText primaryTypographyProps={{fontSize: "0.8rem"}}>Present from beginning</ListItemText>
          </MenuItem>
        </Menu>
      </div>
  );
};

export default PresentationSplitButton;
